<template>
  <div class="activeChecks">
    <div class="check-list">
      <div class="check-item" v-for="(item, index) in checklist" :key="index">
        <van-icon name="location" size="20" color="#007AFF" />
        <div class="check-info">
          <div class="check-address">{{ item.signArea }}</div>
          <div class="time-label">签到时段:</div>
          <div class="check-time" v-for="(time, index2) in item.signTimeList" :key="index2">{{ time }}</div>
        </div>
        <img src="../../assets/image/activecheck/check-bgimg.png" class="check-bgimg" alt="" />
      </div>
    </div>
    <div class="check-bottom">
      <div class="check-message-1" v-if="!ischeck">
        <div class="message-left">
          <van-icon name="location" size="18" color="#FFAA00" />
          <div style="margin-left: 4px; font-size: 14px">您不在签到有效区域，不能签到</div>
        </div>
        <div class="message-right" @click="reposition">
          <i class="iconfont iconicon-refresh-right"></i>
          <div style="margin-left: 6px; font-size: 14px">重新定位</div>
        </div>
      </div>
      <div class="check-message-2" v-if="ischeck">
        <div class="message-left">
          <van-icon name="location" size="18" color="#17BE6B" />
          <div style="margin-left: 4px">您在签到有效区域，可以签到</div>
        </div>
      </div>
      <div class="check-btnbox">
        <van-button :disabled="!ischeck" class="check-btn" @click="check" size="normal" type="primary" round>
          立即签到
        </van-button>
      </div>
    </div>
    <!-- 全屏 Loading -->
    <div class="loading-overlay" v-if="isLoading">
      <div class="loading-content">
        <van-loading type="spinner" size="40px" color="#007AFF" />
        <p class="loading-text">正在定位中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import {geteventSignInfo, checksigns, signactive} from '@/api'
export default {
  data() {
    return {
      checklist: [],
      ischeck: false,
      locationInfo: null, // 定位结果
      toastShow: false, // 提示框显示状态
      toastMsg: '', // 提示信息
      geolocation: null, // 定位实例
      isLoading: false // 添加定位加载状态
    }
  },

  components: {},
  mounted() {
    // 初始化定位实例（提前初始化避免重复创建）
    this.initGeolocation()
    this.getcheckAddress()
  },
  beforeDestroy() {
    // 销毁定位实例，避免内存泄漏
    if (this.geolocation) {
      this.geolocation = null
    }
  },

  methods: {
    check() {
      console.log('立即签到')
      const params = {
        eventSignId: this.$route.query.id,
        signLatitude: this.locationInfo.lat,
        signLongitude: this.locationInfo.lng,
        signName: this.locationInfo.address
      }
      signactive(params).then(res => {
        if (res.success) {
          this.$toast('签到成功')
        }
      })
    },
    reposition() {
      console.log('重新定位')
      this.getCurrentLocation()
    },
    // 初始化高德地图定位实例
    initGeolocation() {
      // 检查高德地图 API 是否加载完成
      console.log(window.AMap, 56656)

      if (!window.AMap) {
        console.log('高德地图API加载失败，请刷新页面重试')
        return
      }

      // 创建定位实例，配置参数
      this.geolocation = new window.AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000, // 定位超时时间，默认：5s
        maximumAge: 0, // 定位结果缓存时间，默认：0s（不缓存）
        convert: true, // 是否自动偏移坐标，高德坐标转高德加密坐标，默认：true
        showButton: false, // 是否显示定位按钮，默认：true
        buttonPosition: 'LB', // 定位按钮位置，默认：'LB'（左下角）
        showMarker: false, // 是否显示定位点标记，默认：true
        showCircle: false, // 是否显示定位精度圆，默认：true
        panToLocation: false, // 定位成功后是否自动移动地图到定位点，默认：true
        zoomToAccuracy: false, // 定位成功后是否自动调整地图视野到定位精度范围，默认：true
        extensions: 'all' // 获取详细地址信息
      })

      this.getCurrentLocation()
    },

    // 点击按钮获取当前位置
    getCurrentLocation() {
      if (!this.geolocation) {
        this.initGeolocation()
        return
      }
      console.log(333)

      this.isLoading = true
      this.locationInfo = null

      // 使用箭头函数确保 this 指向正确
      this.geolocation.getCurrentPosition((status, result) => {
        console.log(result, 555)

        // 定位成功
        if (status === 'complete') {
          if (result.formattedAddress && result.addressComponent) {
            this.handleLocationSuccess(result)
          } else {
            // 如果没有地址信息，使用逆地理编码
            this.convertCoordinatesToAddress(result)
          }
        } else {
          // 定位失败
          this.handleLocationError(result)
        }

        // 这里 this 指向正确的Vue实例
        this.isLoading = false
        console.log(this.isLoading)
      })
    },
    // 将坐标转换为地址信息
    convertCoordinatesToAddress(result) {
      const lng = Array.isArray(result.position) ? result.position[0] : result.position.lng || result.position.getLng()
      const lat = Array.isArray(result.position) ? result.position[1] : result.position.lat || result.position.getLat()

      // 创建地理编码实例
      const geocoder = new window.AMap.Geocoder({
        city: '全国'
      })

      geocoder.getAddress([lng, lat], (status, geoResult) => {
        if (status === 'complete' && geoResult.info === 'OK') {
          // 合并定位结果和地理编码结果
          const combinedResult = {
            ...result,
            ...geoResult.regeocode,
            position: [lng, lat]
          }
          this.handleLocationSuccess(combinedResult)
        } else {
          // 如果逆地理编码也失败，至少保留坐标信息
          this.handleLocationSuccess({
            formattedAddress: `经度: ${lng}, 纬度: ${lat}`,
            addressComponent: {},
            position: {
              getLng: () => lng,
              getLat: () => lat
            }
          })
        }
      })
    },
    // 处理定位成功结果
    handleLocationSuccess(result) {
      // 提取关键信息：地址、经纬度
      let lng, lat

      // 获取经度
      if (Array.isArray(result.position)) {
        lng = result.position[0]
      } else if (typeof result.position.getLng === 'function') {
        lng = result.position.getLng()
      } else {
        lng = result.position.lng
      }

      // 获取纬度
      if (Array.isArray(result.position)) {
        lat = result.position[1]
      } else if (typeof result.position.getLat === 'function') {
        lat = result.position.getLat()
      } else {
        lat = result.position.lat
      }

      this.locationInfo = {
        address: result.formattedAddress || result.regeocode?.formattedAddress || '无法获取地址信息', // 格式化地址
        province: result.addressComponent?.province || result.regeocode?.addressComponent?.province || '未知省份', // 省
        city: result.addressComponent?.city || result.regeocode?.addressComponent?.city || '未知城市', // 市
        district: result.addressComponent?.district || result.regeocode?.addressComponent?.district || '未知区县', // 区/县
        lng: lng, // 经度
        lat: lat // 纬度
      }
      console.log('定位结果：', this.locationInfo)
      this.checksign()
    },
    // 处理定位失败
    handleLocationError(error) {
      let errorMsg = '定位失败'
      switch (error.info) {
        case 'PERMISSION_DENIED':
          errorMsg = '请允许浏览器获取位置权限'
          break
        case 'POSITION_UNAVAILABLE':
          errorMsg = '位置信息不可用'
          break
        case 'TIMEOUT':
          errorMsg = '定位请求超时，请重试'
          break
        case 'UNKNOWN_ERROR':
          errorMsg = '未知错误导致定位失败'
          break
        default:
          errorMsg = `定位失败：${error.info}`
      }
      console.error('定位失败原因：', errorMsg)
    },
    checksign() {
      const params = {
        eventSignId: this.$route.query.id,
        signLatitude: this.locationInfo.lat,
        signLongitude: this.locationInfo.lng,
        signName: this.locationInfo.address
      }
      checksigns(params).then(res => {
        if (res.success) {
          this.ischeck = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getcheckAddress() {
      const params = {
        eventSignId: this.$route.query.id,
        forType: 22
      }
      geteventSignInfo(params).then(res => {
        this.checklist = res.data.eventSignConfigMobileList
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activeChecks {
  width: 100%;
  min-height: calc(100vh - 210px);
  .check-list {
    height: calc(100vh - 318px);
    padding: 16px;
    overflow-y: auto;
    .check-item {
      display: flex;
      background-color: #fff;
      min-height: 113px;
      margin-bottom: 12px;
      padding: 16px;
      position: relative;
      .check-info {
        flex: 1;
        margin-left: 6px;
        .check-address {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
        }
        .time-label {
          font-size: 14px;
          color: #808080;
          margin-top: 12px;
        }
        .check-time {
          font-size: 14px;
          color: #808080;
          margin-top: 8px;
        }
      }
      .check-bgimg {
        width: 60px;
        height: 60px;
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
  }
  .check-bottom {
    height: 108px;
    position: absolute;
    bottom: 0;
    width: 100%;
    .check-message-1 {
      height: 40px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff9ed;
      width: 100%;
      .message-left {
        display: flex;
        align-items: center;
      }
      .message-right {
        display: flex;
        align-items: center;
        color: #ffaa00;
      }
    }
    .check-message-2 {
      height: 40px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      background: #dcf5e9;
      .message-left {
        display: flex;
        align-items: center;
      }
    }
    .check-btnbox {
      height: 68px;
      width: 100%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      .check-btn {
        width: 90%;
        height: 44px;
        background-color: #007aff;
        border-radius: 44px; // 这个会与 round 属性配合使用
        color: #fff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none; // 确保没有默认边框
        &::before {
          display: none; // 去除可能的伪元素
        }
      }
    }
  }
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); // 半透明遮罩
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; // 确保在最顶层

    .loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: white;
      padding: 30px;
      border-radius: 10px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

      .loading-text {
        margin-top: 15px;
        color: #333;
        font-size: 16px;
        text-align: center;
      }
    }
  }
}
</style>
